import React from "react";

const View = () => {
  return <div>View Customer</div>;
};

export default View;
